module.exports = __webpack_public_path__ + "img/onboarding-header-dark.bfe9c6a7.svg";